import { useEffect, useState } from 'react';
import { TlearningCategory } from '../../../type/learningCategory';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
	Navigation,
	Pagination,
	Scrollbar,
	A11y,
	Autoplay,
} from 'swiper/modules';
import { MINIO } from '../../../data/data';
// Import Swiper styles
import 'swiper/css';
import { postDataPages } from '../../../service/categoryLearning';
import { Link } from 'react-router-dom';
import DynamicFaIcon from '../../atoms/DynamicFaIcon';

interface CategoryLearningItemProps {
	category: TlearningCategory;
}

const CategoryLearningItem = ({ category }: CategoryLearningItemProps) => {
	const [imgError, setImgError] = useState(false);
	const hasThumbnail = !!category.thumbnail && !imgError;

	return (
		<Link to={`learning/category/${category.slug}`}>
			<div className="flex flex-col justify-center items-center">
				{hasThumbnail ? (
					<img
						src={`${MINIO}/${category.thumbnail}`}
						alt={category.name}
						className="w-14 h-14 rounded-full object-cover"
						onError={() => setImgError(true)}
					/>
				) : (
					<div className="w-14 h-14 rounded-full bg-gray-200 flex items-center justify-center">
						<DynamicFaIcon name={'FaImage'} />
					</div>
				)}
				<span className="mt-3 text-[11px] text-center block line-clamp-2">
					{category.name}
				</span>
			</div>
		</Link>
	);
};

const CategoryLearning = () => {
	const [learningCategorys, setLearningCategorys] = useState<
		TlearningCategory[]
	>([]);

	const getDataCategory = async () => {
		const data = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: '',
				},
			],
		};
		const response = await postDataPages(data);
		if (!response?.error) {
			setLearningCategorys(response?.data.content);
		}
	};

	useEffect(() => {
		getDataCategory();
	}, []);
	return (
		<>
			<Swiper
				modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
				spaceBetween={25}
				slidesPerView={5}
				centeredSlides={false}
				autoplay={{
					delay: 1000,
					disableOnInteraction: true,
				}}
			>
				{learningCategorys.map((item: TlearningCategory, index: number) => {
					return (
						<SwiperSlide key={index}>
							<CategoryLearningItem category={item} />
						</SwiperSlide>
					);
				})}
			</Swiper>
		</>
	);
};

export default CategoryLearning;
